/**
 * 쓰다 만 기록 초안 (인용·생각·쪽수).
 *
 * localStorage 에 둔다. 전자책 앱에서 문장을 복사해 오거나 쪽수를 확인하러 다녀오는
 * 사이 휴대폰이 앱을 꺼버리면, sessionStorage 는 함께 비워져서 붙여넣어 둔 문장이
 * 사라졌다. 저장하거나 지우면 초안도 지운다.
 */

const PREFIX = 'br_rec_draft_';

/** 하단 입력창의 본문. 답글이면 부모마다 따로 */
export const composerDraftKey = (bookId, parentId = null) =>
  parentId ? `${PREFIX}${bookId}_${parentId}` : `${PREFIX}${bookId}`;

/** 인용과 함께 쓰는 '내 생각' */
export const thoughtDraftKey = (bookId) => `${PREFIX}${bookId}_with`;

/** 입력창의 쪽수 */
export const pageDraftKey = (bookId, parentId = null) => `${composerDraftKey(bookId, parentId)}_page`;

/** 전체화면 작성 — { type, text, page } */
export const focusDraftKey = (bookId) => `${PREFIX}${bookId}_focus`;

export const loadDraft = (key) => {
  try { return localStorage.getItem(key) || ''; }
  catch { return ''; }
};

/** 빈 값이면 지운다 */
export const saveDraft = (key, value) => {
  try {
    if (value) localStorage.setItem(key, value);
    else localStorage.removeItem(key);
  } catch { /* 저장 실패는 무시 */ }
};

/*
 * 마지막으로 기록을 남긴 책. 전자책에서 문장을 옮길 때는 같은 책에 여러 번 연달아 들어오므로,
 * 빠른 기록 창과 공유받은 문장 화면이 이 책을 미리 골라 둔다.
 */
const LAST_BOOK_KEY = 'br_quick_record_book';

export const readLastRecordBook = () => {
  try { return localStorage.getItem(LAST_BOOK_KEY); }
  catch { return null; }
};

export const rememberRecordBook = (bookId) => {
  try { if (bookId) localStorage.setItem(LAST_BOOK_KEY, bookId); }
  catch { /* 저장 실패는 무시 */ }
};

/** 책을 지울 때 그 책의 초안을 모두 지운다 (답글 초안까지) */
export const clearBookDrafts = (bookId) => {
  try {
    const base = `${PREFIX}${bookId}`;
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      // 'abc' 를 지울 때 'abcd' 의 초안까지 지우지 않도록 구분자까지 맞춘다
      if (key === base || key?.startsWith(`${base}_`)) keys.push(key);
    }
    keys.forEach(key => localStorage.removeItem(key));
  } catch { /* 무시 */ }
};
